import { createSlice } from "@reduxjs/toolkit";
import { deleteBookingAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteBookingSlice = createSlice({
  name: "deleteBooking",
  initialState: data,
  reducers: {
   deleteBookingSlice(state) {
      state.isLoading = true;
    },
   deleteBookingSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteBookingSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteBookingSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteBookingHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteBookingAction.deleteBookingSlice());
    const response: any = await deleteBookingAPI(id);
    
    dispatch(deleteBookingAction.deleteBookingSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteBookingAction.deleteBookingSliceFailure(e?.response?.data));
  }
};
export default deleteBookingSlice.reducer;
export const deleteBookingAction = deleteBookingSlice.actions;
